import { useContext } from 'react';
import { Button, Col, Row } from "react-bootstrap";
import { AddFileNavigationPositionEnum } from '../../../../domain/enum/AddFileNavigationPosition';
import { AddDocumentModalContext } from '../context/AddDocumentModalContext';

export function IndexScreen() {
    const {
        setNavigationPosition
    } = useContext(AddDocumentModalContext);
    return <>
        <Row>
            <Col>
                <p>
                    Como você quer enviar seu documento?
                </p>
            </Col>
        </Row>
        <Row className="py-2">
            <Col>
                <Button className='w-100 add-content px-3' onClick={() => setNavigationPosition(AddFileNavigationPositionEnum.verifyFile)}>
                    <Row className="mb-2">
                        <Col md="auto" className="my-auto pr-0">
                            <i className="bi bi-upload" />
                        </Col>
                        <Col className="my-auto">
                            <h3>
                                Enviar arquivo do meu dispositivo
                            </h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <p>
                                São aceitos arquivos nos formatos .pdf, doc, docx, ppt, pptx, txt, com tamanho de até 50MB.
                            </p>
                        </Col>
                    </Row>
                </Button>
            </Col>
        </Row>
    </>;
}


